// extracted by mini-css-extract-plugin
module.exports = {"container":"e_qu","sizeMedium":"e_ru","sizeSmall":"e_su","icon":"e_tu"};